export function between(min: number, value: number, max: number): number {
  return Math.max(min, Math.min(value, max));
}

export function isBetween(input: number, min: number, max: number): boolean {
  return input >= min && input <= max;
}
